/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Header info.
 */
export interface HeaderInfo {
  /**
   * Count of transfers without associated account.
   */
  pendingTransfers: number;
  /**
   * Count of pending settlements.
   */
  pendingSettlements: number;
  /**
   * Count of pending fireblocks settlements.
   */
  pendingFireblocksSettlements: number;
}
